/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Basic_Keyword_GroupInputs */

const en_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Keyword Group`)
};

const fr_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe de mots clés de base`)
};

const de_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlegende Schlüsselwortgruppe`)
};

const it_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di parole chiave di base`)
};

const ru_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовая группа ключевых слов`)
};

const es_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo básico de palabras clave`)
};

const zh_cn2_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本关键词组`)
};

const ja_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本キーワードグループ`)
};

const hi_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुनियादी कीवर्ड समूह`)
};

const pt_pt2_subtitle_export_basic_keyword_group = /** @type {(inputs: Subtitle_Export_Basic_Keyword_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de palavras-chave básicas`)
};

/**
* | output |
* | --- |
* | "Basic Keyword Group" |
*
* @param {Subtitle_Export_Basic_Keyword_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_basic_keyword_group = /** @type {((inputs?: Subtitle_Export_Basic_Keyword_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Basic_Keyword_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_basic_keyword_group(inputs)
	if (locale === "de") return de_subtitle_export_basic_keyword_group(inputs)
	if (locale === "it") return it_subtitle_export_basic_keyword_group(inputs)
	if (locale === "ru") return ru_subtitle_export_basic_keyword_group(inputs)
	if (locale === "es") return es_subtitle_export_basic_keyword_group(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_basic_keyword_group(inputs)
	if (locale === "ja") return ja_subtitle_export_basic_keyword_group(inputs)
	if (locale === "hi") return hi_subtitle_export_basic_keyword_group(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_basic_keyword_group(inputs)
	return en_subtitle_export_basic_keyword_group(inputs)
});